import styled from 'styled-components';

const BREAK_POINT = '900px';

export const Ul = styled.ul`
  margin: 40px 0 0 0;
  padding: 0;

  @media only screen and (min-width: ${BREAK_POINT}) {
    margin: 350px 0 0 0;
  }
`;

export const Container = styled.section`
  display: flex;
  padding: 80px 30px;
  min-height: 600px;
  max-width: 1600px;
  margin: 0 auto;
  flex-direction: column;
  position: relative;
  align-items: center;

  @media only screen and (min-width: ${BREAK_POINT}) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Title = styled.h2`
  font-size: 26px;
  margin-bottom: 0px;

  @media only screen and (min-width: 1280px) {
    font-size: 26px;
  }
`;

export const LeftContent = styled.div`
  max-width: 500px;
  height: 100%;
  margin-bottom: 0;

  @media only screen and (min-width: 1280px) {
    max-width: 600px;
    margin-bottom: 130px;
  }
`;

export const Subtitle = styled.h3`
  font-size: 22px;
  font-weight: 500;
  max-width: 396px;
  margin: 0;
  padding: 0;
  color: #888;
`;

export const StepContentWrapper = styled.div`
  display: flex;
  padding: 20px 0;
`;

export const Image = styled.img`
  width: 100%;
`;

export const StepCopy = styled.div`
  max-width: 95%;
  margin-left: 0px;
`;

export const P = styled.p`
  font-size: 18px;
  margin-top: 0;

  @media only screen and (min-width: ${BREAK_POINT}) {
    margin-top: 10px;
  }
`;

export const Left = styled.div`
  padding: 20px;

  @media only screen and (min-width: ${BREAK_POINT}) {
    flex-direction: row;
    width: 50%;
    position: -webkit-sticky;
    position: sticky;
    top: calc(50vh - 180px);
    height: 100%;
  }
`;

export const Right = styled.div`
  padding: 20px;
  @media only screen and (min-width: ${BREAK_POINT}) {
    width: 50%;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/ESSPoints/BatteryPix/styles.js